import { css } from '@emotion/react'

export const align = css`
  display: flex;
  align-items: center;
`
